/**
 * VZBuch Infinite Scroll v14 (Incremental Logic Fix)
 * Verhindert das Rückwärts-Laden durch strikte Seitenzahl-Kontrolle.
 */
(function() {
  let isLoading = false;
  let nextUrl = null;
  let highestPageLoaded = 1;

  const selectors = {
    grid: '#product-grid',
    item: '.grid__item',
    pagination: '.pagination-wrapper'
  };

  /**
   * Hilfsfunktion: Zieht die Seitenzahl aus einer URL
   */
  const extractPageNumber = (url) => {
    if (!url) return 0;
    const match = url.match(/page=(\d+)/);
    return match ? parseInt(match[1]) : 1;
  };

  /**
   * Sucht gezielt nach dem Link, der genau EINE Seite weiter führt
   */
  const findRealNextUrl = (doc = document) => {
    const allLinks = doc.querySelectorAll('.pagination a, a.pagination__item');
    let targetUrl = null;

    allLinks.forEach(link => {
      const pageNum = extractPageNumber(link.href);
      // Nur den Link nehmen, der exakt die nächste Seite ist (z.B. 3 + 1 = 4)
      if (pageNum === highestPageLoaded + 1) {
        targetUrl = link.href;
      }
    });

    return targetUrl;
  };

  /**
   * Die Lade-Funktion
   */
  const loadMore = async () => {
    if (isLoading || !nextUrl) return;

    isLoading = true;
    console.log('VZ Scroll: Suche Seite ' + (highestPageLoaded + 1) + '...');

    const grid = document.querySelector(selectors.grid);
    if (!grid) return;

    // Loader anzeigen
    let loader = document.getElementById('vz-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'vz-loader';
      loader.style.cssText = 'text-align:center; padding: 40px; width:100%; grid-column: 1/-1; color:#2980b9; font-weight:bold;';
      loader.innerHTML = '⏳ Seite ' + (highestPageLoaded + 1) + ' wird aufgeschlagen...';
      grid.appendChild(loader);
    }

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const nextDoc = parser.parseFromString(html, 'text/html');

      const newItems = nextDoc.querySelectorAll('#product-grid > .grid__item');
      
      if (newItems.length > 0) {
        if (loader) loader.remove();

        newItems.forEach(item => {
          grid.appendChild(document.importNode(item, true));
        });

        // Seitenzahlen unten im Browser für dich aktualisieren
        const newPagination = nextDoc.querySelector(selectors.pagination);
        const currentPagination = document.querySelector(selectors.pagination);
        if (newPagination && currentPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        }

        // Stand aktualisieren
        highestPageLoaded++;
        nextUrl = findRealNextUrl(nextDoc);
        console.log('VZ Scroll: Seite ' + highestPageLoaded + ' geladen. Nächstes Ziel: ' + (nextUrl ? highestPageLoaded + 1 : 'Ende'));

        window.dispatchEvent(new Event('resize'));
      } else {
        nextUrl = null;
      }

    } catch (e) {
      console.error('VZ Scroll Fehler:', e);
      nextUrl = null;
    } finally {
      isLoading = false;
    }
  };

  // Filter-Wächter (Reset bei neuen Filtern)
  const observer = new MutationObserver(() => {
    console.log('VZ Scroll: AJAX Filter erkannt. Reset auf Seite 1.');
    highestPageLoaded = extractPageNumber(window.location.href);
    nextUrl = findRealNextUrl();
  });

  const init = () => {
    highestPageLoaded = extractPageNumber(window.location.href);
    nextUrl = findRealNextUrl();
    const container = document.getElementById('ProductGridContainer');
    if (container) observer.observe(container, { childList: true });
  };

  // Scroll-Event
  window.addEventListener('scroll', () => {
    const scrollBottom = window.innerHeight + window.scrollY;
    const threshold = document.documentElement.scrollHeight - 1100;
    if (scrollBottom >= threshold) {
      loadMore();
    }
  }, { passive: true });

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();